import React, { Component } from "react"
import PropTypes from "prop-types"
import filter from "lodash/filter"
import uniqBy from "lodash/uniqBy"
import isEmpty from "lodash/isEmpty"
import { dealerInfo } from "apis/dealer-search"
import { withRadium, DetectCompact } from "higher-order-components"
import COLOR_PALETTE from "constants/color-palette"
import { CheckBox, EditIcon, CancelIcon, LoaderIcon, Button, DealerSearchBoxNZ } from "components"
import DealerDetails from "./details"
import { gtmFindADealerActionTypes } from "store/gtm-events"

class DealerSummary extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dealers: props.initialLocations || [],
      editMode: !(props.initialLocations && props.initialLocations[0]),
      loading: false,
      searchInput: {
        postcode:
          props.initialLocations && props.initialLocations[0]
            ? String(props.initialLocations[0].postcode)
            : ""
      },
      tempDealer:
        props.initialLocations && props.initialLocations[0]
          ? {
              dealerCode: props.initialLocations[0].dealerCode,
              id: props.initialLocations[0].id,
              name: props.initialLocations[0].name
            }
          : {},
      fields: {
        postcode: {}
      }
    }

    this.onEdit = () => {
      const { editMode, dealers } = this.state
      const { value } = this.props

      if (!value) return

      this.setState({
        editMode: !editMode || !dealers.length,
        tempDealer: {
          dealerCode: value.code,
          id: value.id,
          name: value.name
        },
        dealers: uniqBy(
          filter(dealers, {
            dealerCode: value.code,
            id: value.id,
            name: value.name
          }),
          "id"
        )
      })
    }

    this.onDealerSelect = () => {
      const { tempDealer } = this.state
      this.setState({
        editMode: false,
        dealers: filter(this.state.dealers, {
          dealerCode: tempDealer.dealerCode,
          id: tempDealer.id,
          name: tempDealer.name
        })
      })

      this.onChange(tempDealer)
    }
  }

  componentDidMount() {
    const { initialLocations } = this.props
    initialLocations && initialLocations.length && this.onChange(initialLocations[0])
  }

  onChange(location) {
    const { onChange } = this.props
    onChange({
      id: location.id,
      code: location.dealerCode,
      name: location.name
    })
  }

  updateLocations = () => {
    this.setState(
      {
        loading: true
      },
      () => {
        const { value } = this.props
        dealerInfo({ ...this.state.searchInput, dealerTypes: ["service"] })
          .then(({ response }) => {
            const selectedDealerList = value ? filter(
              this.state.dealers,
              {
                dealerCode: value.code,
                id: value.id,
                name: value.name
              }
            ) : {}
            this.setState({
              tempDealer: value
                ? {
                    dealerCode: value.code,
                    id: value.id,
                    name: value.name
                  }
                : {},
              dealers:
                uniqBy(
                  [
                    ...selectedDealerList,
                    ...response
                  ],
                  "id"
                ) || [],
              loading: false
            })
          })
          .catch(console.warn.bind(console))
      }
    )
  }

  updateLocationInSearchInput = search => {
    if (!search) return
    this.setState(
      {
        searchInput: {
          dealerCode: search.dealerCode,
          postcode: search.postcode
        }
      },
      () => {
        this.updateLocations()
      }
    )
  }

  render() {
    const { value = {}, type } = this.props
    const { dealers, editMode, loading } = this.state

    return (
      <div style={{ margin: "2em 0 1em" }}>
        {editMode && (
          <div style={{ marginBottom: "2em" }}>
            <p
              style={{
                fontWeight: 200,
                lineHeight: 1.6,
                overflow: "hidden",
                textAlign: "left",
                color: COLOR_PALETTE.BLACK
              }}>
              {!isEmpty(value) && (
                <span
                  style={{
                    padding: "0 0 2em 3em",
                    float: "right",
                    cursor: "pointer",
                    color: COLOR_PALETTE.GRAY_DARK,
                    ":hover": { color: COLOR_PALETTE.BLACK }
                  }}
                  onClick={() => this.onEdit()}>
                  <CancelIcon
                    style={{
                      fill: "currentColor",
                      width: "20px",
                      height: "20px",
                      margin: "0 0.5em -3px 0"
                    }}
                  />
                  <span style={{ fontSize: "14px", fontWeight: "400" }}>
                    Cancel
                  </span>
                </span>
              )}
              Enter a dealer name, postcode or suburb to find your nearest Mazda dealerships.
            </p>

            <DealerSearchBoxNZ
              searchOverride={""}
              dealerSearchEndPoint={this.props.dealerSearchEndPoint || "/api/dealer-search"}
              onChange={this.updateLocationInSearchInput}
              componentRestrictions={
                { country: 'nz' } // handleAutocomplete
              }
              updateLocations={this.updateLocationInSearchInput}
              gtmMapping={gtmFindADealerActionTypes}
            />
          </div>
        )}
        {loading && <LoaderIcon styleName="light" />}
        {dealers.length > 0 &&
          dealers.map(location => {
            return location.id && (
              <div
                key={location.id}
                style={{
                  display:
                    (!editMode && value.id !== location.id) || (editMode && value.id === location.id)
                      ? "none"
                      : "flex",
                  flexDirection: "row",
                  color: COLOR_PALETTE.BLACK
                }}>
                {editMode && (
                  <div style={{ padding: ".25em" }}>
                    <CheckBox
                      checked={this.state.tempDealer.id === location.id}
                      onClick={() => {
                        this.setState({
                          tempDealer: {
                            dealerCode: location.dealerCode,
                            id: location.id,
                            name: location.name
                          }
                        })
                      }}
                      style={{ margin: "0 1em .5em 0" }}
                    />
                  </div>
                )}
                <div
                  style={{
                    flexGrow: 1,
                    lineHeight: 1.2,
                    fontWeight: 300,
                    cursor: "pointer"
                  }}>
                  <DealerDetails compact={this.props.compact} location={location} type={type} />
                </div>
                {!editMode && (
                  <div
                    style={{ cursor: "pointer", width: "4em", lineHeight: "25px", textAlign: "center" }}
                    onClick={() => this.onEdit()}>
                    <EditIcon style={{ width: "20px", height: "20px", marginBottom: "-3px" }} />{" "}
                    <span style={{ fontSize: "14px", fontWeight: "400", color: COLOR_PALETTE.GRAY_DARK, ":hover": { color: COLOR_PALETTE.BLACK } }}>Edit</span>
                  </div>
                )}
              </div>
            )}
          )}
        {editMode ? (
          <Button
            onClick={this.onDealerSelect}
            label="Select dealer"
            disabled={this.state.tempDealer.id === value.id}
            display="block"
            styleName="black">
            Select dealer
          </Button>
        ) : null}
      </div>
    )
  }
}

DealerSummary.propTypes = {
  compact: PropTypes.bool,
  type: PropTypes.oneOf(["service", "sales", "parts"]),
  dealerApiEndPoint: PropTypes.string.isRequired,
  dealerSearchEndPoint: PropTypes.string,
  initialLocations: PropTypes.array,
  value: PropTypes.shape({
    id: PropTypes.string,
    code: PropTypes.string
  }),
  onChange: PropTypes.func
}

export default withRadium(DetectCompact())(DealerSummary)



// WEBPACK FOOTER //
// ./src/components/mymazda/dealer/summary.jsx